import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiTaxFormSection' })(
  ({ breakpoints, typography }) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: typography.pxToRem(50),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingBottom: typography.pxToRem(34),
      },
    },
    mobileTitle: {
      textWrap: 'pretty',
      fontSize: '4rem',
      fontWeight: 500,
      lineHeight: '4.5rem',
      letterSpacing: '-0.02rem',
      paddingTop: typography.pxToRem(29),
      paddingLeft: typography.pxToRem(22),
      marginBottom: 0,
      [breakpoints.up(ScreenSize.MEDIUM)]: {
        display: 'none',
      },
    },
    title: {
      textWrap: 'pretty',
      fontSize: '4rem',
      fontWeight: 500,
      lineHeight: '4.5rem',
      marginBottom: '1.875rem',
      letterSpacing: '-0.02rem',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        display: 'none',
      },
    },
    twoColumnTable: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      paddingTop: typography.pxToRem(88),
      paddingBottom: 0,
      [breakpoints.down(ScreenSize.LARGE)]: {
        flexDirection: 'column-reverse',
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingTop: typography.pxToRem(41),
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: typography.pxToRem(30),
      flex: 2,
      [breakpoints.down(ScreenSize.LARGE)]: {
        paddingTop: '2.125rem;',
        paddingRight: typography.pxToRem(30),
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(24),
        paddingRight: typography.pxToRem(24),
      },
    },
    form: {
      flex: 1,
    },
    imageSection: {
      width: '100%',
      height: '100%',
      padding: 0,
      marginTop: typography.pxToRem(60),
      marginBottom: typography.pxToRem(29),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        padding: 0,
      },
    },
  })
);

export default useStyles;
